import { render, staticRenderFns } from "./myPre.vue?vue&type=template&id=6ed8d200&"
import script from "./myPre.vue?vue&type=script&lang=js&"
export * from "./myPre.vue?vue&type=script&lang=js&"
import style0 from "./myPre.vue?vue&type=style&index=0&id=6ed8d200&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports